<template>
  	<div class="stores" @click='topHide' style="height:100%">
    	<div class="breadcrumb">课程管理 > 指定用户课程列表</div>
	    <div class="searchBtn" style="border:none;display:flex">
	      	<el-button size='small' type="primary" @click="add" plain>添加/编辑指定用户</el-button>
			<div class="topinput">
				<input type="text" placeholder="请输入教练名称" class="el-input__inner" v-model="nickname" @keyup="search" @keyup.enter="search_mine()"/>
				<ul class="nickNameul" v-if="fuzzyQueryShow">
					<li v-for="item in nicknameData" @click="nicknameitem(item.id,item.nickName)">{{item.nickName}}</li>
				</ul>
			</div>
	      	<el-date-picker
	      		v-model="timeVal"
	      		type="daterange"
	      		range-separator=" 至 "
	      		start-placeholder="课程开始日期"
	      		end-placeholder="课程结束日期"
      			value-format="yyyy-MM-dd">
	    	</el-date-picker>
	    	<el-button type="primary" @click="search_mine()">搜索</el-button>

	    </div>
	    <div class="topnav" style="margin:15px 0 20px">
	    	<li :class="{active:cur==-1}" @click="topnav(-1)">全部</li>
	    	<li v-for="(item,index) in selData" :class="index==cur?'active':''" @click="topnav(index,item.id)">{{item.name}}</li>
	    </div>
    	<div class="main">
	      	<template>
	        	<el-table ref="multipleTable" :data="tableData" highlight-current-row  style="width: 100%" @current-change="handleCurrentChange">
			        <el-table-column prop="id" label="ID"></el-table-column>
			        <el-table-column prop="coachName" label="课程教练" show-overflow-tooltip></el-table-column>
			        <el-table-column prop="name"  label="课程名称" show-overflow-tooltip></el-table-column>
			        <el-table-column prop="courseTagVos"  label="课程标签">
			        	<template slot-scope="scope" >
			            	<el-tag v-for="(item,index) in scope.row.courseTagVos" :key="index" style="margin:5px">{{item.tagName}}</el-tag>
			        	</template>
			        </el-table-column>
			        <el-table-column prop="sportKindName"  label="运动类型名称" show-overflow-tooltip></el-table-column>
			        <el-table-column prop="beginTime"  :formatter="this.global.dateFormat" label="课程开始时间" show-overflow-tooltip></el-table-column>
			        <el-table-column prop="endTime" :formatter="this.global.dateFormat" label="课程结束时间" show-overflow-tooltip></el-table-column>
		        </el-table>
	      	</template>
	      	<div class="block" style="padding:30px 10px; float:right">
	        	<el-pagination @current-change="handleCurrentChangePage" :current-page="pageNum" :page-size="limit" layout="total, prev, pager, next, jumper" :total="totalPage"></el-pagination>
	      	</div>
	    </div>

	    <!-- 选择教练弹框 -->
	    <el-dialog title="指定用户" :visible.sync="dialogVisible" width="35%" :before-close="handleClose">
	    	<div class="searchTop">
	    		<el-input type="textarea" :rows="5" v-model="mobiles"  placeholder="请输入手机号，多个手机号“英文”状态下逗号 “ , ” 隔开" style="width:100%"></el-input>
	    		<el-button type="primary" @click="onSubmit">添加</el-button>
	    	</div>
	    	
	      	<el-scrollbar style="height:500px; width:100%;cursor:pointer">
	        	<template>
	          		<el-table ref="multipleTable" :data="coachesData" highlight-current-row tooltip-effect="dark" style="width: 100%">
		            	<el-table-column prop="id" align="center" label="ID"></el-table-column>
		            	<el-table-column prop="userName" align="center" label="名字" show-overflow-tooltip></el-table-column>
	          		</el-table>
	        	</template>
		        <div class="block" style="padding:30px 10px; float:right">
		          	<el-pagination @current-change="handleCurrentChangePage2" :current-page="pageNum2" :page-size="limit2" layout="total, prev, pager, next, jumper" :total="totalPage2"></el-pagination>
		        </div>
	      	</el-scrollbar>
	    </el-dialog>
	    
  	</div>
</template>  
<script>
export default {
  	components: {},
  	mounted() {
  		this.userId=localStorage.getItem("userId")
    	this.page(this.pageNum,this.limit,this.userId,this.sportsKindId,this.coachId,this.nickname,this.beginTime,this.endTime)
    	this.sportsKind()	
  	},
  	data() {
    	return {
    		cur:-1,
    		userId:'',
	      	headers: {
	        	xqiao_token: localStorage.getItem("token")
	      	},
      		tmpFiles: process.env.API_ROOT + "/tmpFiles",
      		selData: [], //选择运动种类
      		tableData: [], //初始化表格
      		pageNum: 1,
      		limit: 10,
      		totalPage: 10,
      		coachesData: [], //教练列表
      		pageNum2: 1,
      		limit2: 10,
      		totalPage2: 10,
      		currentRow: "",
	      	dialogVisible: false,
	   		nickname:'',
	   		fuzzyQueryShow:false,
	   		timeVal:'',
	   		mobiles:''
	    };
  	},
  	methods: {
	    //初始化表格数据
	    page(pageNum,limit,userId,sportsKindId,coachId,nickname,beginTime,endTime){
	    	var params=this.calculate();
	    	this.$get("/course/getAssignUserCourse", params)
	        .then(res => {
	          	if (res.code == 0) {
	            	this.tableData = res.data.list;
	            	this.totalPage = res.data.total;
	          	} else {
		            this.$message({
		              	message: res.message,
		              	type: "warning"
		            });
		            return false;
	          	}
	        })
	        .catch(() => {
	         	console.log();
	        });
	    },
	    calculate(){
	    	var dataFer = {
	    		pageNum:this.pageNum,
	    		limit:this.limit,
	    		userId:this.userId,
	        	sportsKindId:this.sportsKindId,
	        	nickname:this.nickname,
	        	visibility:5
		    }
		    if(this.coachId){
		    	dataFer.coachId=this.coachId
		    }
		    if(this.timeVal){	
		    	dataFer.beginTime=this.$moment(this.timeVal[0]).valueOf();
		    	dataFer.endTime=this.$moment(this.timeVal[1]).valueOf();
		    }
		    return dataFer;
	    },
	    search(){//模糊查询
	    	this.coachId='';
	  		if(this.nickname){
	  			var params = {
		        	pageNum: 1,
		        	limit: this.limit,
		        	nickname:this.nickname
		      	};
	  			this.$get("/coaches/nickname", params)
		        .then(res => {
		        	console.log(res)
		          	if (res.code == 0) {
		            	this.nicknameData=res.data.list;
		            	if(res.data.list.length>0){
		            		this.fuzzyQueryShow=true;
		            	}
		          	} else {
			            this.$message({
			              	message: res.message,
			              	type: "warning"
			            });
			            return false;
		          	}
		        })
	  		}else{
	  			this.nicknameData=[];
	  			this.fuzzyQueryShow=false;
	  		}
	  	},
	  	nicknameitem(id,name){
	  		this.coachId=id;
	  		this.nickname=name;
	  		this.fuzzyQueryShow=false;
	  	},
	  	search_mine(){
	  		this.pageNum=1;
	  		this.page(this.pageNum,this.limit,this.userId,this.sportsKindId,this.coachId,this.nickname,this.beginTime,this.endTime)
	  	},
	  	topHide(){
	  		this.fuzzyQueryShow=false;
	  	},
	    //当前页数
	    handleCurrentChangePage(val) {
	      	this.pageNum = val;
	      	this.page(this.pageNum,this.limit,this.userId,this.sportsKindId,this.coachId,this.nickname,this.beginTime,this.endTime)
	    },
	    //当前教练页数
	    handleCurrentChangePage2(val) {
	      	this.pageNum2 = val;
	      	this.selCoachesData();
	    },
	    //弹框关闭按钮
	    handleClose(done) {
	      	done()
	    },
	    //选择需要修改的权限
	    handleCurrentChange(val) {
	      	if (val) {
		        this.currentRow = val.id;
	      	}
	    },
	    //选择教练
	    selCoachesData() {
	      	var params = {
	        	pageNum: this.pageNum2,
	        	limit: this.limit2,
	        	courseId:this.currentRow,
	      	};
	      	if (this.currentRow) {
	      		this.$get("/course/getUserCourseVisibility", params)
		        .then(res => {
		        	console.log(res)
		          	if (res.code == 0) {
		          		this.dialogVisible = true;
			            this.coachesData = res.data.list;
			            this.totalPage2 = res.data.total;
		          	} else {
		            	this.$message({
			              	message: res.message,
			              	type: "warning"
			            });
		            	return false;
		          	}
		        })
	      	} else {
		        this.dialogVisible = false;
		        this.$message({
		          	message: "请选择信息",
		          	type: "warning"
		        });
		        return false;
	      	}
	    },
	    //选择运动种类
	    sportsKind() {
	      	this.$get("/course/sportsKind", {})
	        .then(res => {
	          	console.log(res)
	          	if (res.code == 0) {
	            	this.selData = res.data;
	          	} else {
		            this.$message({
		              	message: res.message,
		              	type: "warning"
		            });
	            	return false;
	          	}
	        })
	        .catch(() => {
	          	console.log();
	        });
	    },
	    //添加
	    add(row) {
	    	console.log(this.currentRow)
	    	this.selCoachesData();
	    },
	    topnav(e,id){
	    	if(e!=-1){
	    		this.sportsKindId=id
	    	}else{
	    		this.sportsKindId=0
	    	}
	    	this.pageNum=1;
 			this.cur=e;
 			this.page(this.pageNum,this.limit,this.userId,this.sportsKindId,this.coachId,this.nickname,this.beginTime,this.endTime)
 		},
 		onSubmit(){
 			var tel = this.mobiles,mobiles;
      		mobiles=tel.split(",")
	    	console.log(mobiles.join())
	    	//return false
	    	var ruleForm={
	    		courseId:this.currentRow,
	    		mobiles:mobiles.join()
	    	}
	    	this.$post("/course/addUserCourseVisibility", JSON.stringify(ruleForm))
          	.then(res => {
         		var str='';
         		if(res.code==0){
         			this.mobiles='';
              		this.pageNum2 = 1;
              		this.selCoachesData();
         		}else{
         			this.$message({
		              	message: res.message,
		              	type: "warning"
		            });
	            	return false;
         		}
          	})
 		}
  	}
};
</script>

<style scoped>
.searchBtn .el-range-editor.el-input__inner{
	margin: 0 15px
}
.topinput{
	position: relative;
	margin-left: 15px;
	width: 250px
}
.topinput input{
	font-size: 13px;
}
.nickNameul{
	position: absolute;
	background: #fff;
	width: 100%;
	padding: 10px;
	font-size: 13px;
	line-height: 25px;
	border: 1px solid #DCDFE6;
	border-top: none
}
.nickNameul li{
	color: #666;
	cursor: pointer;
}
.nickNameul li:hover{
	color: #409EFF
}
.searchTop{
	display: flex;
}
.searchTop button{
	height: 40px;
	margin-left: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/coursesList/specifiedCourseList.vue